import { lazy } from "react"
import type { FC, LazyExoticComponent } from "react"

async function loader(): Promise<{ default: FC }> {
    return import("./assistant.participant-sessions.page").then(
        ({ AssistantParticipantSessionsPage: PSP }): { default: FC } => ({
            default: PSP
        })
    )
}

const AssistantParticipantSessionsPage: LazyExoticComponent<FC> = lazy((): Promise<{ default: FC }> => loader())

export { AssistantParticipantSessionsPage }

async function assistantParticipantSessionsPagePreloader(): Promise<void> {
    await loader()
}

export { assistantParticipantSessionsPagePreloader }
